/**
 * Keep version traffic weights as a closed 100% pie.
 * Raising one slider steals from the others (largest first).
 * Lowering one slider gives the freed share to the largest other.
 */
function rebalanceTrafficSplit(weights, changedId, rawNext) {
  const ids = Object.keys(weights || {});
  const current = Math.max(0, Math.min(100, Math.round(Number(weights?.[changedId]) || 0)));
  const wanted = Math.max(0, Math.min(100, Math.round(Number(rawNext) || 0)));
  const out = {};
  for (const id of ids) {
    out[id] = Math.max(0, Math.min(100, Math.round(Number(weights[id]) || 0)));
  }
  if (!ids.length) return out;
  if (ids.length === 1) {
    out[changedId] = 100;
    return out;
  }

  out[changedId] = wanted;
  let delta = wanted - current;
  const others = ids.filter((id) => id !== changedId);
  const rank = (a, b) => (out[b] - out[a]) || (ids.indexOf(a) - ids.indexOf(b));

  if (delta > 0) {
    const ranked = [...others].sort(rank);
    for (const id of ranked) {
      if (delta <= 0) break;
      const take = Math.min(out[id], delta);
      out[id] -= take;
      delta -= take;
    }
    if (delta > 0) out[changedId] = wanted - delta;
  } else if (delta < 0) {
    const ranked = [...others].sort(rank);
    out[ranked[0]] += -delta;
  }

  const total = ids.reduce((sum, id) => sum + out[id], 0);
  if (total !== 100 && ids.length) {
    const fixId = [...ids].sort(rank)[0];
    out[fixId] = Math.max(0, out[fixId] + (100 - total));
  }
  return out;
}

export { rebalanceTrafficSplit };
